/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecutionsAvailable } from './ExecutionsAvailable';
import {
    ExecutionsAvailableFromJSON,
    ExecutionsAvailableFromJSONTyped,
    ExecutionsAvailableToJSON,
} from './ExecutionsAvailable';

/**
 * 
 * @export
 * @interface FindOneExecutionsAvailableByFacilityId200Response
 */
export interface FindOneExecutionsAvailableByFacilityId200Response {
    /**
     * 
     * @type {ExecutionsAvailable}
     * @memberof FindOneExecutionsAvailableByFacilityId200Response
     */
    data?: ExecutionsAvailable;
}

/**
 * Check if a given object implements the FindOneExecutionsAvailableByFacilityId200Response interface.
 */
export function instanceOfFindOneExecutionsAvailableByFacilityId200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindOneExecutionsAvailableByFacilityId200ResponseFromJSON(json: any): FindOneExecutionsAvailableByFacilityId200Response {
    return FindOneExecutionsAvailableByFacilityId200ResponseFromJSONTyped(json, false);
}

export function FindOneExecutionsAvailableByFacilityId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOneExecutionsAvailableByFacilityId200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ExecutionsAvailableFromJSON(json['data']),
    };
}

export function FindOneExecutionsAvailableByFacilityId200ResponseToJSON(value?: FindOneExecutionsAvailableByFacilityId200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ExecutionsAvailableToJSON(value.data),
    };
}

